import { render, staticRenderFns } from "./AtomCustomer.vue?vue&type=template&id=3e013398&"
import script from "./AtomCustomer.vue?vue&type=script&lang=js&"
export * from "./AtomCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AtomCustomer.vue?vue&type=style&index=0&id=3e013398&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports